import {
  PlanEventInformation,
  PlanMeasureKey,
} from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";
import InfraEventCard from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/InfraEventCard";
import TrainEventCard from "features/CenterContent/RoleContent/EventHandling/components/TrainEventCard";
import {
  eventIsInfrastructureEvent,
  eventIsTrainEvent,
} from "features/History/utils/utils";
import { FC, useMemo } from "react";
import { Flex, tokens, VStack } from "shared/components/Spor";
import { useTheme } from "styled-components";

type EventStateColumnProps = {
  measures: PlanEventInformation[];
  columnEventState: PlanMeasureKey;
  showClosed?: boolean;
};

export const EventStateColumn: FC<EventStateColumnProps> = ({
  measures,
  columnEventState,
  showClosed = true,
}) => {
  const theme = useTheme();

  // Sort events by createdAt date, Newest first
  const sortedMeasures = useMemo(
    () =>
      measures
        .filter(
          ({ information }) => showClosed || information.state !== "CLOSED",
        )
        .toSorted((a, b) => {
          const infoA = a.information;
          const infoB = b.information;
          const dateA = infoA.createdAt
            ? new Date(infoA.createdAt)
            : new Date(0);
          const dateB = infoB.createdAt
            ? new Date(infoB.createdAt)
            : new Date(0);
          return dateB.getTime() - dateA.getTime();
        }),
    [measures],
  );

  return (
    <Flex
      backgroundColor={theme.colorBackgroundSecondary}
      borderRadius={tokens.default.size.spacing[1]}
      flexDirection="column"
      width="100%"
      p={tokens.default.size.spacing[1]}
      overflowY="auto"
    >
      <VStack gap={tokens.default.size.spacing[1]}>
        {sortedMeasures.length !== 0
          ? sortedMeasures.map((measure) => {
              const { information, internalMessages } = measure;
              const key = `${information.uuid}-${information.version}`;
              if (eventIsInfrastructureEvent(information)) {
                return (
                  <InfraEventCard
                    key={key}
                    event={information}
                    internalMessages={internalMessages}
                    columnEventState={columnEventState}
                  />
                );
              }
              if (eventIsTrainEvent(information)) {
                return (
                  <TrainEventCard
                    key={key}
                    event={information}
                    internalMessages={internalMessages}
                    columnEventState={columnEventState}
                  />
                );
              }
              return null;
            })
          : null}
      </VStack>
    </Flex>
  );
};
